import {
  SITUACAO_KEY_ACORDO_IA,
  SITUACAO_KEY_ACORDO_MANUAL,
  SITUACAO_KEY_INTERVENCAO_HUMANA,
  type NegociacaoSituacaoSummary,
} from '@/features/negociacoes';

interface SituacaoTag {
  id: string;
  label: string;
  tone: 'warning' | 'neutral';
}

const SUPPRESSED_KEYS = new Set<string>([SITUACAO_KEY_ACORDO_MANUAL, SITUACAO_KEY_ACORDO_IA]);

export const getSituacaoTags = (situacoes: NegociacaoSituacaoSummary[]): SituacaoTag[] =>
  situacoes
    .filter((situacao) => !SUPPRESSED_KEYS.has(situacao.key))
    .map((situacao) => ({
      id: situacao.id,
      label: situacao.label,
      tone: situacao.key === SITUACAO_KEY_INTERVENCAO_HUMANA ? 'warning' : 'neutral',
    }));
